import styled from 'styled-components'

import type { PacingStatus } from '~/modules/retailMedia/services/campaign/spend-reports'

const PACING_INDICATOR_COLOR: Record<PacingStatus, string> = {
  on_track: '#20b038',
  underpacing: '#e9c701',
  critical_underpacing: '#f95d47',
  overpacing: '#e08300'
}

const PACING_FILL_BLUE = '#3993f4'
const PACING_FILL_DARK = '#014592'

export const Root = styled.div<{ $compact?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $compact }) => ($compact ? 0 : '4px')};
  align-items: stretch;
  width: 100%;
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: 100%;
  min-width: 0;
`

export const HeaderBody = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
`

export const IndicatorWrap = styled.span<{ $pacing: PacingStatus }>`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  color: ${({ $pacing }) => PACING_INDICATOR_COLOR[$pacing]};
`

/** Dot (on track) */
export const BadgeDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
`

/** Triangles for under / over pacing */
export const BadgeArrowUp = styled.span`
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 5px solid currentColor;
`

export const BadgeArrowDown = styled.span`
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid currentColor;
`

export const BarTrack = styled.div`
  background-color: ${({ theme }) => theme.colors.tertiary};
  border-radius: 50px;
  height: 8px;
  position: relative;
  width: 100%;
  overflow: hidden;
`

export const BarFillSingle = styled.div<{ $widthPct: number }>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: inherit;
  width: ${({ $widthPct }) => `${Math.min($widthPct, 100)}%`};
  background-color: ${PACING_FILL_BLUE};
`

/** Light blue base + dark blue segment from left (overpacing) */
export const BarFillOverBase = styled.div`
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background-color: ${PACING_FILL_BLUE};
`

export const BarFillOverDark = styled.div<{ $widthPct: number }>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: inherit;
  width: ${({ $widthPct }) => `${$widthPct}%`};
  background-color: ${PACING_FILL_DARK};
`
